import { Tile, TileContent, TileGroup, TileText, Typography, } from '@one-thd/sui-atomic-components';
import { Calendar } from '@one-thd/sui-icons';
import { DateTime } from 'luxon';
import React, { useEffect } from 'react';
import { MORE_DATES_VALUE } from '../../../../constants/general';
import { useOrderContext } from '../../../../hooks/useContexts';
export var formatDeliveryDate = function (estStartDeliveryDate) {
    var startDate = DateTime.fromISO(estStartDeliveryDate);
    var today = DateTime.local().startOf('day');
    var tomorrow = today.plus({ days: 1 });
    var prefix = '';
    if (startDate.hasSame(today, 'day')) {
        prefix = 'Today';
    }
    else if (startDate.hasSame(tomorrow, 'day')) {
        prefix = 'Tomorrow';
    }
    return {
        prefix: prefix,
        dayOfWeek: startDate.toFormat('ccc'),
        monthDay: startDate.toFormat('LLL d'),
        shortFullDate: "".concat(prefix ? prefix + ', ' : '').concat(startDate.toFormat('ccc LLL d')),
        longFullDate: "".concat(prefix ? prefix + ', ' : '').concat(startDate.toFormat('cccc LLLL d')),
    };
};
export var BodfsDateTiles = function () {
    var _a = useOrderContext(), availableDeliverySlots = _a.availableDeliverySlots, selectedDateId = _a.selectedDateId, showCalendar = _a.showCalendar, setSelectedDateId = _a.setSelectedDateId, setShowCalendar = _a.setShowCalendar, setSelectedDeliverySlot = _a.setSelectedDeliverySlot, setDeliveryDate = _a.setDeliveryDate;
    var showMoreDatesTile = availableDeliverySlots.length > 6;
    var visibleSlots = showMoreDatesTile
        ? availableDeliverySlots.slice(0, 5)
        : availableDeliverySlots;
    var selectedDeliverySlot = availableDeliverySlots.find(function (slot) { return slot.id === selectedDateId; });
    useEffect(function () {
        if (selectedDeliverySlot) {
            setSelectedDeliverySlot(selectedDeliverySlot);
        }
    }, [selectedDateId]);
    var _b = selectedDeliverySlot
        ? formatDeliveryDate(selectedDeliverySlot.startDateTime)
        : { shortFullDate: '', longFullDate: '' }, shortFullDate = _b.shortFullDate, longFullDate = _b.longFullDate;
    var getValue = function (id) {
        if (showCalendar || id === MORE_DATES_VALUE) {
            return MORE_DATES_VALUE;
        }
        return selectedDateId;
    };
    var getDeliveryDate = function () {
        var startDateTime = availableDeliverySlots[0].startDateTime;
        if (selectedDateId === MORE_DATES_VALUE) {
            return {
                shortFullDate: formatDeliveryDate(startDateTime).shortFullDate || '',
                longFullDate: formatDeliveryDate(startDateTime).longFullDate || '',
            };
        }
        return { shortFullDate: shortFullDate, longFullDate: longFullDate };
    };
    useEffect(function () {
        setDeliveryDate(getDeliveryDate().longFullDate);
    }, [selectedDateId, availableDeliverySlots]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, null,
            "Delivery Scheduled for:",
            ' ',
            React.createElement("span", { className: "sui-font-bold", "data-testid": "delivery-date" }, getDeliveryDate().shortFullDate)),
        React.createElement(TileGroup, { value: getValue(selectedDateId), onChange: function (_event, id) {
                // When there is no value change the id is null
                if (id === null) {
                    return;
                }
                if (id === MORE_DATES_VALUE) {
                    setSelectedDeliverySlot(null);
                    setSelectedDateId(MORE_DATES_VALUE);
                    setShowCalendar(true);
                }
                else {
                    setSelectedDateId(id);
                    setShowCalendar(false);
                }
            }, "aria-label": "rate", className: "sui-mt-4 sui-mb-1 sui-grid sui-grid-cols-3 sui-gap-2 sui-w-full" },
            visibleSlots.map(function (slot) {
                var _a = formatDeliveryDate(slot.startDateTime), prefix = _a.prefix, dayOfWeek = _a.dayOfWeek, monthDay = _a.monthDay, shortDate = _a.shortFullDate;
                return (React.createElement(Tile, { key: slot.id, value: slot.id, "aria-label": shortDate, grow: true },
                    React.createElement(TileContent, { orientation: "vertical" }, prefix ? (React.createElement(React.Fragment, null,
                        React.createElement(TileText, null, "".concat(prefix, ", ")),
                        React.createElement(TileText, null,
                            dayOfWeek,
                            " ",
                            monthDay))) : (React.createElement(React.Fragment, null,
                        React.createElement(TileText, null, dayOfWeek),
                        React.createElement(TileText, null, monthDay))))));
            }),
            showMoreDatesTile && (React.createElement(Tile, { key: MORE_DATES_VALUE, value: MORE_DATES_VALUE, "aria-label": "more dates", grow: true },
                React.createElement(TileContent, { orientation: "vertical" },
                    React.createElement(Calendar, { size: "small" }),
                    React.createElement(TileText, null, "More Dates"))))),
        React.createElement(Typography, { variant: "body-sm" }, "Select any available delivery date at no additional cost")));
};
